<template>
  <div class="h-screen flex flex-col">
    <NuxtLoadingIndicator/>
    <AppHeader />
    <div class="flex flex-1 overflow-auto">
      <div class="flex flex-1 overflow-auto">
        <slot/>
      </div>
    </div>
    <UNotifications />
  </div>
</template>

<style scoped>

</style>
<script setup lang="ts">
import {AppHeader} from "#components";
</script>